/**
 * ScheduleV2Card — S2.6 (Observabilidade V2).
 *
 * Card READ-ONLY que exibe a "Agenda V2" PERSISTIDA mas DORMENTE — os
 * eventos foram gravados no firmware (schedCfgV2) porém NÃO são executados
 * (o scheduler ativo continua sendo o v1). Visualmente distinto da agenda
 * real (tracejado + esmaecido + badge "DORMENTE · NÃO EXECUTA").
 *
 * Proibido por design: NÃO mostra next_run / próxima / última execução nem
 * qualquer indício de que executa. Só aparece quando há entries V2.
 */
import { parseScheduleV2 } from "../../lib/scheduleCore.js";

const _DOW = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

export default function ScheduleV2Card({ snapshot }) {
  const v2 = parseScheduleV2(snapshot);
  // Só aparece quando há eventos V2 persistidos.
  if (!v2 || !v2.entries || v2.entries.length === 0) return null;

  // S2.9 — badge DINÂMICO conforme o estado real reportado pelo firmware.
  const executing = v2.executionEnabled === true;

  return (
    <div className={"ipwd-schedv2-card" + (executing ? " is-active" : "")}>
      <div className="ipwd-schedv2-head">
        <span className="ipwd-schedv2-title">🧪 Agenda V2 (persistida)</span>
        <span className={"ipwd-schedv2-badge" + (executing ? " is-active" : "")}>
          {executing ? "ATIVA · EXECUTANDO" : "DORMENTE · NÃO EXECUTA"}
        </span>
      </div>

      <div className="ipwd-schedv2-state">
        estado: <b>{v2.schedulerState}</b> · execução:{" "}
        <b>{v2.executionEnabled ? "ligada" : "desligada"}</b> · ativo no device:{" "}
        <b>{v2.activeScheduler || "—"}</b> · {v2.count} evento(s)
      </div>

      <div className="ipwd-schedv2-entries">
        {v2.entries.map((e, i) => (
          <div key={i} className="ipwd-schedv2-entry">
            <span className="ipwd-schedv2-time">{e.time || "--:--"}</span>
            <span className="ipwd-schedv2-days">
              {(e.days || []).map((d) => _DOW[d]).join(", ") || "—"}
            </span>
            <span className="ipwd-schedv2-dur">
              {e.duration_s != null ? `${e.duration_s}s` : "—"}
            </span>
            <span className="ipwd-schedv2-act">{e.action || "relay_reboot"}</span>
          </div>
        ))}
      </div>

      <div className="ipwd-schedv2-foot">
        Pré-visualização — não substitui a agenda ativa (v1).
      </div>
    </div>
  );
}
